import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { deltaToDHM } from 'automation-ui-flow-core/fields/time/timeUtils';
import * as ChronoUnit from 'automation-ui-flow-core/fields/time/ChronoUnit';
import TimeDelay from 'automation-ui-flow-core/fields/time/TimeDelay';
import TimeDelta from 'automation-ui-flow-core/fields/time/TimeDelta';
import FormattedList from 'I18n/components/FormattedList';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedTimeDelay = ({
  timeDelay
}) => {
  const {
    timeUnit,
    delta
  } = timeDelay;
  if (timeUnit === ChronoUnit.MONTHS) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.delay.month-unsupported",
      options: {
        count: delta
      }
    });
  }
  const [days, hours, minutes] = deltaToDHM(Math.abs(Number(delta)), timeUnit);
  const formattedDurations = [];
  if (days) {
    const translatedDays = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.delay.action-detail.formatted-time-delay.days",
      options: {
        count: days
      }
    }, "days");
    formattedDurations.push(translatedDays);
  }
  if (hours) {
    const translatedHours = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.delay.action-detail.formatted-time-delay.hours",
      options: {
        count: hours
      }
    }, "hours");
    formattedDurations.push(translatedHours);
  }
  if (minutes || !formattedDurations.length) {
    const translatedMinutes = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.delay.action-detail.formatted-time-delay.minutes",
      options: {
        count: minutes
      }
    }, "minutes");
    formattedDurations.push(translatedMinutes);
  }
  return /*#__PURE__*/_jsx(FormattedList, {
    children: formattedDurations
  });
};
FormattedTimeDelay.propTypes = {
  timeDelay: PropTypes.oneOfType([PropTypes.instanceOf(TimeDelay), PropTypes.instanceOf(TimeDelta)]).isRequired
};
export default FormattedTimeDelay;